"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileRedesign = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const useFetchSvg_1 = __importDefault(require("../../../common/helpers/Hooks/useFetchSvg"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const ChatTileBadge_1 = __importDefault(require("./ChatTileBadge"));
const useAppUid_1 = require("../../behaviours/useAppUid");
const CardWrapper = styled_components_1.default.div `
  .MuiCardContent-root {
    text-align: center;
    height: 80px;
    display: flex;
    align-items: center;
  }

  .display-flex {
    display: flex;
    justify-content: start;
    padding: 3px;
  }

  .card-image {
    width: 122px;
    border-radius: 5px;
  }
`;
const CardTitle = styled_components_1.default.p `
  color: #212121;
  font-weight: 200;
  font-size: 1rem;
  margin: 0 auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 120px;

  @media (min-width: 1024px) {
    max-width: 152px;
  }
`;
const TileWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100px;

  .tile-title {
    padding: 0 4px;
    line-height: 16px;
    letter-spacing: 0.4px;
    font-weight: 400;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    margin-top: 3px;
    width: 100%;
    @media (min-width: 1024px) {
      margin-top: 7px;
    }

    @media (min-width: 769px) {
      font-size: 0.875rem; // body2
    }
  }
`;
const IconsBox = styled_components_1.default.div `
  position: relative;
  background-color: ${(props) => {
    /* eslint-disable prefer-destructuring */
    const { position, theme } = props;
    if (!position && position !== 0) {
        return theme.palette.mainAppColor.main;
    }
    const colorTiles = theme.palette.colorTiles;
    const chosenColor = colorTiles[position % colorTiles.length];
    return chosenColor;
    /* eslint-disable prefer-destructuring */
}};

  &.bareiss {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: ${() => "url( /images/other/bareissTransparent.png )"};
  }

  height: 65px;
  width: 100%;
  max-width: 65px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SvgWrapper = styled_components_1.default.div `
  div {
    height: 35px;
  }

  svg {
    height: 35px;
    width: auto;

    path,
    circle,
    rect {
      fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
      stroke: transparent;
    }
  }

  &.svg-temp-fix {
    path:first-of-type {
      fill: unset;
    }
  }
`;
const TileImage = styled_components_1.default.div `
  border-radius: 10px;
  background: ${(props) => `url(${props.image} )`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 65px;
  width: 100%;
  max-width: 65px;
`;
const TileLink = styled_components_1.default.div `
  cursor: pointer;
  text-align: center;
  margin-bottom: 10px;

  @media (min-width: 744px) {
    margin-bottom: 14px;
  }

  width: 25%; // 4

  @media (min-width: 500px) {
    width: 16.66%; // 6
  }

  @media (min-width: 744px) {
    width: 12.5%; // 8
  }

  @media (min-width: 1024px) {
    width: 10%; // 10
  }
`;
const TileRedesign = (props) => {
    const { navType, image, svg, title, withCard, withIcon, withBackgroundImage, location, destination, history, position, tileClassName, isRenderOnBrandLevel, isMovingCarousel, isBareissBrand, userData, currentLocale, offers, directories, onTileClick, } = props;
    const [activity, setActivity] = (0, react_1.useState)(null);
    const transformBookingUrl = (0, useAppUid_1.useAppUid)();
    const withHttp = (url) => (!/^https?:\/\//i.test(url) ? `http://${url}` : url);
    const renderDirectoryModal = (item) => {
        if (item.folder) {
            const redirectLocation = item.folder.deeplink
                ? new URL(item.folder.deeplink).pathname
                : `/directory/folder/${item.folder.title.toLowerCase().replace(/ /g, "-")}`;
            return history.push({
                pathname: redirectLocation,
                search: location.search,
            });
        }
        if (item.page) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: item.page,
            });
        }
        if (item.website) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: item.website,
            });
        }
        if (item.document) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: item.document,
            });
        }
        return null;
    };
    const renderOffersModal = (item) => {
        if (item.folder) {
            const redirectLocation = item.folder.deeplink
                ? new URL(item.folder.deeplink).pathname
                : `/directory/folder/${item.folder.title.toLowerCase().replace(/ /g, "-")}`;
            return history.push({
                pathname: redirectLocation,
                search: location.search,
            });
        }
        if (item.offer) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: item.offer,
            });
        }
        if (item.website) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                activeItem: item.website,
            });
        }
        return null;
    };
    const getActivityFullData = (id) => apiService_1.default.getActivity(currentLocale, userData.token, id);
    const getActivity = (currentUrl) => __awaiter(void 0, void 0, void 0, function* () {
        const contentFullId = `-${currentUrl.split("--").pop()}`;
        yield getActivityFullData(contentFullId).then((data) => setActivity(data));
    });
    const checkContent = (url) => {
        if (url.includes("/directory")) {
            const flattenedCollection = helpers_1.Helpers.flattenCollection(directories, true);
            flattenedCollection.forEach((directory) => {
                const type = Object.keys(directory)[0];
                if (directory[type].deeplink) {
                    if (directory[type].deeplink === url) {
                        renderDirectoryModal(directory);
                    }
                }
            });
        }
        if (url.includes("/offers")) {
            const flattenedCollection = helpers_1.Helpers.flattenCollection(offers, true);
            flattenedCollection.forEach((offer) => {
                const type = Object.keys(offer)[0];
                if (offer[type].deeplink) {
                    if (offer[type].deeplink === url) {
                        renderOffersModal(offer);
                    }
                }
            });
        }
        if (url.includes("/activities")) {
            return helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                content: activity,
            });
        }
        return null;
    };
    (0, react_1.useEffect)(() => {
        if (destination) {
            const { url, type } = destination;
            if (type === "deeplink" && url && url.includes("/activities")) {
                getActivity(url);
            }
        }
    }, []);
    const handleTileClick = () => {
        if (onTileClick) {
            onTileClick();
            return;
        }
        if (destination) {
            const { url, type } = destination;
            switch (type) {
                case "internal":
                    history.push({
                        pathname: url,
                        search: location.search,
                    });
                    break;
                case "deeplink":
                    checkContent(url);
                    break;
                default:
                    const processedUrl = transformBookingUrl(withHttp(url));
                    window.open(processedUrl, "_blank");
                    break;
            }
        }
    };
    const renderTile = () => {
        if (withCard && image) {
            return (react_1.default.createElement(CardWrapper, null,
                react_1.default.createElement(material_1.Card, { className: ` ${isRenderOnBrandLevel ? "" : "no-box-shadow"}` },
                    react_1.default.createElement(material_1.CardActionArea, { className: ` ${isRenderOnBrandLevel ? "" : "display-flex card-action-area"}` },
                        react_1.default.createElement(material_1.CardMedia, { component: "img", image: image, className: ` ${isRenderOnBrandLevel ? "" : "card-image"}` }),
                        react_1.default.createElement(material_1.CardContent, null,
                            react_1.default.createElement(CardTitle, null, title))))));
        }
        // We use this because we get a lot of different svg structures, delete it when the correct svg is added
        const temporarySvgFix = svg && svg.includes("tab_spa") ? "svg-temp-fix" : "";
        const isSvgLinkPresent = svg && svg.endsWith(".svg");
        const bareissClass = isBareissBrand ? "bareiss" : "";
        if (withIcon && svg) {
            const loadedSvg = isSvgLinkPresent && (0, useFetchSvg_1.default)(svg);
            return (react_1.default.createElement(TileWrapper, { className: bareissClass },
                react_1.default.createElement(IconsBox, { position: position, className: bareissClass },
                    navType === "chat" && react_1.default.createElement(ChatTileBadge_1.default, null),
                    isSvgLinkPresent && (react_1.default.createElement(SvgWrapper, { className: temporarySvgFix },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: loadedSvg,
                            } })))),
                react_1.default.createElement(material_1.Typography, { variant: "caption", className: "tile-title" }, title)));
        }
        if (withBackgroundImage) {
            return (react_1.default.createElement(TileWrapper, { position: position, className: bareissClass },
                react_1.default.createElement(TileImage, { image: image }),
                react_1.default.createElement(material_1.Typography, { variant: "caption", className: "tile-title" }, title)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    return (react_1.default.createElement(TileLink, { onClick: (e) => {
            if (isMovingCarousel) {
                return e.preventDefault();
            }
            return handleTileClick();
        }, className: tileClassName }, renderTile()));
};
exports.TileRedesign = TileRedesign;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    navigations: store.getValue("navigations"),
    offers: store.getValue("offers"),
    directories: store.getValue("directory"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.TileRedesign));
